import React, { useState, useCallback, useEffect } from "react";
import { ChangingLanguage } from "../../shared/components/ChangingLanguage";
import { useTranslation } from "react-i18next";
import { normalizedLocale } from "../../common/libs/normalizedLocale";
import { Formik, Field, Form } from 'formik';
import { FaExclamationCircle } from "react-icons/fa";
import style from "./autorization.module.css";
import * as Yup from "yup";
import Cookies from "js-cookie"; // Для работы с куками
import { authenticate, sentEmail, getUserInfo } from "../../common/api/authApi";
import { useNavigate, useLocation } from "react-router-dom";
import { useAppDispatch } from "../../shared/hook";
import { useStore } from "react-redux";
import ModalComponent from "../../shared/Ui/ModalComponent/ModalWindow";
import ModalButton from "../../shared/Ui/Buttons/ModalButtons";
import { log } from "node:console";
import EmailCheckModal from "../../shared/EmailCheck/EmailCheck";
import { login, updateUserData } from "../../shared/slice/authSlice";
import mockUser from "./utils/mock";
import mockAdmin from "./utils/mockAdmin";
import { RootState } from "../../store";
import AlertBox from "../../shared/Ui/AlertBox/AlertBox";
import { acceptEmployeeInvitation } from "../../common/api/tradePointApi";
import PasswordRecoveryModal from '../../shared/EmailCheck/PasswordRecoveryModal';

const Authorization: React.FC = () => {
  const { t, i18n } = useTranslation();
  const locale = normalizedLocale(i18n.language);
  const navigate = useNavigate();
  const location = useLocation();
  const [showPassword, setShowPassword] = useState(false);
  const [errorModal, setErrorModal] = useState<any>(null);
  const [activeTab, setActiveTab] = useState("login");
  const existingData = JSON.parse(localStorage.getItem('TableData') || 'null');
  const [emailWindow, setEmailWindow] = useState<any>(null);
  const dispatch = useAppDispatch();
  const store = useStore<RootState>();
  const adminData = {
    username: "admin",
    password: "111"
  }
  const userData = {
    username: "irina.m",
    password: "111"
  }
  const [alertOpen, setAlertOpen] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [showRecovery, setShowRecovery] = useState(false);

  // Схема валидации для входа
  const loginValidationSchema = Yup.object().shape({
    username: Yup.string().required('Введите логин'),
    password: Yup.string().required('Введите пароль'),
  });

  // Схема валидации для регистрации
  const registrationValidationSchema = Yup.object().shape({
    name: Yup.string()
      .required('Введите имя')
      .min(2, 'Имя должно содержать минимум 2 символа'),
    surname: Yup.string()
      .required('Введите фамилию')
      .min(2, 'Фамилия должна содержать минимум 2 символа'),
    email: Yup.string()
      .email('Некорректный email')
      .required('Введите email'),
    password: Yup.string()
      .required('Введите пароль')
      .min(8, 'Пароль должен содержать не менее 8 символов')
      .matches(
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
        'Пароль должен содержать хотя бы одну строчную букву, одну заглавную букву и одну цифру'
      ),
    repeatPassword: Yup.string()
      .oneOf([Yup.ref('password')], 'Пароли должны совпадать')
      .required('Повторите пароль'),
  });

  // Выбираем схему валидации в зависимости от активной вкладки
  const validationSchema = activeTab === 'login' ? loginValidationSchema : registrationValidationSchema;

  const handleSubmit = useCallback(async (values: any) => {
    try {
      console.log('Начало процесса авторизации');
      const authData = await authenticate(values.username, values.password);
      console.log('Получены данные авторизации:', authData);

      const { access_token, refresh_token, expires_in, refresh_expires_in } = authData.result;

      Cookies.set('access_token', access_token, {
        expires: expires_in / (1000 * 60 * 60 * 24),
        secure: true,
        sameSite: 'Strict',
      });

      Cookies.set('refresh_token', refresh_token, {
        expires: refresh_expires_in / (1000 * 60 * 60 * 24),
        secure: true,
        sameSite: 'Strict',
      });

      console.log('Токены успешно сохранены в cookies');

      // Получаем данные пользователя
      console.log('Получение данных пользователя...');
      const userData = await getUserInfo();
      console.log('Получены данные пользователя:', userData);

      if (userData) {
        // Проверяем структуру данных пользователя
        console.log('Структура данных пользователя:', {
          hasRoles: !!userData.roles,
          rolesLength: userData.roles?.length,
          roles: userData.roles,
          firstRole: userData.roles?.[0],
          firstRoleName: userData.roles?.[0]?.name
        });

        // Проверяем наличие ролей
        if (!userData.roles || userData.roles.length === 0) {
          throw new Error('У пользователя не назначены роли');
        }

        // Получаем роль из ответа сервера
        const userRole = userData.roles[0].name;
        console.log('Роль пользователя из сервера:', userRole);

        // Сохраняем роль в куки
        Cookies.set('role', userRole, {
          expires: refresh_expires_in / (1000 * 60 * 60 * 24),
          secure: true,
          sameSite: 'Strict',
        });

        // Отправляем данные пользователя в Redux store без форматирования
        dispatch(updateUserData(userData));
        dispatch(login());
        console.log('Данные пользователя сохранены в store');
        navigate("/main");
      } else {
        throw new Error('Не удалось получить данные пользователя');
      }
    } catch (error: any) {
      console.error("Ошибка авторизации:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status
      });

      let errorMessage = "Произошла непредвиденная ошибка, попробуйте позже";

      if (error.response?.data?.message) {
        errorMessage = error.response.data.message;
      } else if (error.response?.status === 401) {
        errorMessage = "Неверный логин или пароль";
      } else if (error.response?.status === 404) {
        errorMessage = "Сервер авторизации недоступен";
      } else if (error.message === 'У пользователя не назначены роли') {
        errorMessage = "У пользователя не назначены роли. Обратитесь к администратору.";
      }

      setErrorModal({
        hasError: true,
        errorMessage
      });
    }
  }, [dispatch, navigate]);

  const sendEmail = async (values: any) => {
    // const sendEmail = await sentEmail(values.values.email);
    setEmailWindow(values.values.email)
    try {
      console.log(values.values.email);

      // navigate("/main");
    } catch (error: any) {

      const errorMessage =
        error.response?.data?.message || "Произошла ошибка";
      setErrorModal({ errorMessage });
    }
  }

  const [initialValues, setInitialValues] = useState({
    username: '',
    surname: '',
    password: '',
    name: '',
    email: '',
    secretCode: '',
    repeatPassword: ''
  })

  useEffect(() => {
    const handleInvitationToken = async () => {
      const searchParams = new URLSearchParams(location.search);
      const token = searchParams.get('token');

      if (token) {
        try {
          setIsLoading(true);
          await acceptEmployeeInvitation(token);
          setAlertOpen({
            status: "SUCCESS",
            message: "Приглашение успешно принято. Теперь вы можете войти в систему.",
          });
          // Удаляем токен из URL после успешной обработки
          navigate('/auth', { replace: true });
        } catch (error: any) {
          setAlertOpen({
            status: "error",
            message: error.response?.data?.message || "Ошибка при принятии приглашения",
          });
        } finally {
          setIsLoading(false);
        }
      }
    };

    handleInvitationToken();
  }, [location.search, navigate]);

  return (
    <>
      <Formik
        initialValues={initialValues}
        onSubmit={handleSubmit}
        enableReinitialize={true}
        validateOnBlur={true}
        validateOnChange={true}
        validationSchema={validationSchema}
      >
        {(formik) => (
          <Form>
            <EmailCheckModal
              isOpen={emailWindow}
              email={emailWindow}
              onClose={() => setEmailWindow(null)}
              formik={formik}
              action='registration'
              setErrorModal={setErrorModal}
            />
            <PasswordRecoveryModal
              isOpen={showRecovery}
              onClose={() => setShowRecovery(false)}
              setErrorModal={setErrorModal}
            />
            <div className="bg-bg flex items-center justify-center h-screen">
              <div className="flex flex-col justify-between bg-white p-8 rounded-lg shadow-lg w-96 mx-10">
                {isLoading ? (
                  <div className="flex flex-col items-center">
                    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 mb-4"></div>
                    <p className="text-gray-600">Обработка приглашения...</p>
                  </div>
                ) : (
                  <>
                    <a href="/" className="flex justify-center mb-4 font-bold text-mainColor text-3xl">
                      <img
                        src={`/icons/articool.svg`}
                        alt="E-Track Logo"
                        className={` h-12 origin-left font-medium text-xl duration-200 ${!open && "scale-0"}`}
                      />
                    </a>
                    <div className="flex flex-col">
                      <div className="flex flex-row gap-[20px] mb-4">
                        <span
                          className={`cursor-pointer relative pb-2 ${activeTab === "login" ? "text-mainColor" : "text-gray-500"
                            }`}
                          onClick={() => setActiveTab("login")}
                        >
                          Войти
                          <span
                            className={`absolute bottom-0 left-0 w-full h-[2px] bg-mainColor transition-transform transform origin-left duration-300 ${activeTab === "login" ? "scale-x-100" : "scale-x-0"
                              }`}
                          ></span>
                        </span>
                        <span
                          className={` cursor-pointer relative pb-2 ${activeTab === "register" ? "text-mainColor" : "text-gray-500"
                            }`}
                          onClick={() => setActiveTab("register")}
                        >
                          Регистрация
                          <span
                            className={`absolute bottom-0 left-0 w-full h-[2px] bg-mainColor transition-transform transform origin-left duration-300 ${activeTab === "register" ? "scale-x-100" : "scale-x-0"
                              }`}
                          ></span>
                        </span>
                      </div>
                    </div>
                    {/* Поле логина */}
                    <div className={style.inputField}>
                      {activeTab == 'login' ? (<div className="flex flex-col gap-3">
                        <div>
                          <div className={style.labelAndButtonWrapper}>
                            <label className={style.inputLabel2}>
                              Логин*
                            </label>
                            {formik.touched.username &&
                              formik.errors.username && (
                                <div className={style.tooltipWrapper}>
                                  <FaExclamationCircle className={style.errorIcon} />
                                  <div className={style.tooltipText}>
                                    {typeof formik.errors.username === "string"
                                      ? formik.errors.username
                                      : "Ошибка"}
                                  </div>
                                </div>
                              )}
                          </div>
                          <Field
                            name="username"
                            placeholder={"Введите логин"}
                            className="input"
                          />
                        </div>
                        <div>
                          <div className={style.inputField}>
                            <div className={style.labelAndButtonWrapper}>
                              <label className={style.inputLabel2}>
                                Пароль*
                              </label>
                              {formik.touched.password && formik.errors.password && (
                                <div className={style.tooltipWrapper}>
                                  <FaExclamationCircle className={style.errorIcon} />
                                  <div className={style.tooltipText}>
                                    {typeof formik.errors.password === "string"
                                      ? formik.errors.password
                                      : "Ошибка"}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="relative flex items-center">
                              <Field
                                type={showPassword ? "text" : "password"}  // Меняем тип на 'text', если показываем пароль
                                name="password"
                                placeholder="Введите пароль"
                                className="placeholder" // Ваш класс для стилей
                              />

                              <button
                                type="button"
                                onClick={() => setShowPassword((prev: any) => !prev)}
                                className="absolute right-2" // Позиционирование кнопки
                              >
                                {!showPassword ? (
                                  <img
                                    src="/icons/visible_eye.svg"
                                    alt="Скрыть пароль" // Добавлено свойство alt для доступности
                                    className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                  />
                                ) : (
                                  <img
                                    src="/icons/dis_eye.svg"
                                    alt="Показать пароль"
                                    className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                  />

                                )}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div style={{ textAlign: 'right', marginTop: '-8px', marginBottom: '8px' }}>
                          <button
                            type="button"
                            className="text-xs text-gray-700 hover:underline focus:outline-none"
                            onClick={() => setShowRecovery(true)}
                            tabIndex={0}
                          >
                            Забыли пароль?
                          </button>
                        </div>
                      </div>
                      ) :
                        (<div className="flex flex-col gap-2">
                          <div>
                            <div className={style.inputField}>
                              <div className={style.labelAndButtonWrapper}>
                                <label className={style.inputLabel2}>
                                  Имя*
                                </label>
                                {formik.touched.name && formik.errors.name && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.name === "string"
                                        ? formik.errors.name
                                        : "Ошибка"}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="relative flex items-center">
                                <Field
                                  type="text"   // Меняем тип на 'text', если показываем пароль
                                  name="name"
                                  placeholder="Введите пароль"
                                  className="placeholder" // Ваш класс для стилей
                                />

                              </div>
                            </div>
                          </div>
                          <div>
                            <div className={style.inputField}>
                              <div className={style.labelAndButtonWrapper}>
                                <label className={style.inputLabel2}>
                                  Фамилия*
                                </label>
                                {formik.touched.surname && formik.errors.surname && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.surname === "string"
                                        ? formik.errors.surname
                                        : "Ошибка"}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="relative flex items-center">
                                <Field
                                  name="surname"
                                  placeholder="Введите пароль"
                                  className="placeholder" // Ваш класс для стилей
                                />

                                <button
                                  type="button"
                                  onClick={() => setShowPassword((prev: any) => !prev)}
                                  className="absolute right-2" // Позиционирование кнопки
                                >

                                </button>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className={style.inputField}>
                              <div className={style.labelAndButtonWrapper}>
                                <label className={style.inputLabel2}>
                                  E-mail*
                                </label>
                                {formik.touched.email &&
                                  formik.errors.email && (
                                    <div className={style.tooltipWrapper}>
                                      <FaExclamationCircle className={style.errorIcon} />
                                      <div className={style.tooltipText}>
                                        {typeof formik.errors.email === "string"
                                          ? formik.errors.email
                                          : "Ошибка"}
                                      </div>
                                    </div>
                                  )}
                              </div>
                              <Field
                                name="email"
                                placeholder={"Введите логин"}
                                className="input"
                              />
                            </div>
                          </div>
                          <div>
                            <div className={style.inputField}>
                              <div className={style.labelAndButtonWrapper}>
                                <label className={style.inputLabel2}>
                                  Пароль*
                                </label>
                                {formik.touched.password && formik.errors.password && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.password === "string"
                                        ? formik.errors.password
                                        : "Ошибка"}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="relative flex items-center">
                                <Field
                                  type={showPassword ? "text" : "password"}  // Меняем тип на 'text', если показываем пароль
                                  name="password"
                                  placeholder="Введите пароль"
                                  className="placeholder" // Ваш класс для стилей
                                />

                                <button
                                  type="button"
                                  onClick={() => setShowPassword((prev: any) => !prev)}
                                  className="absolute right-2" // Позиционирование кнопки
                                >
                                  {!showPassword ? (
                                    <img
                                      src="/icons/visible_eye.svg"
                                      alt="Скрыть пароль" // Добавлено свойство alt для доступности
                                      className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                    />
                                  ) : (
                                    <img
                                      src="/icons/dis_eye.svg"
                                      alt="Показать пароль"
                                      className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                    />

                                  )}
                                </button>
                              </div>
                            </div>
                          </div>
                          <div>
                            <div className={style.inputField}>
                              <div className={style.labelAndButtonWrapper}>
                                <label className={style.inputLabel2}>
                                  Повторить пароль*
                                </label>
                                {formik.touched.repeatPassword && formik.errors.repeatPassword && (
                                  <div className={style.tooltipWrapper}>
                                    <FaExclamationCircle className={style.errorIcon} />
                                    <div className={style.tooltipText}>
                                      {typeof formik.errors.repeatPassword === "string"
                                        ? formik.errors.repeatPassword
                                        : "Ошибка"}
                                    </div>
                                  </div>
                                )}
                              </div>
                              <div className="relative flex items-center">
                                <Field
                                  type={showPassword ? "text" : "password"}  // Меняем тип на 'text', если показываем пароль
                                  name="repeatPassword"
                                  placeholder="Введите пароль"
                                  className="placeholder" // Ваш класс для стилей
                                />

                                <button
                                  type="button"
                                  onClick={() => setShowPassword((prev: any) => !prev)}
                                  className="absolute right-2" // Позиционирование кнопки
                                >
                                  {!showPassword ? (
                                    <img
                                      src="/icons/visible_eye.svg"
                                      alt="Скрыть пароль" // Добавлено свойство alt для доступности
                                      className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                    />
                                  ) : (
                                    <img
                                      src="/icons/dis_eye.svg"
                                      alt="Показать пароль"
                                      className="block h-[20px] w-[20px] duration-200 group-hover:brightness-200 group-hover:invert-1"
                                    />

                                  )}
                                </button>
                              </div>
                            </div>
                          </div>

                        </div>)}

                    </div>

                    {/* Поле пароля */}


                    {/* Кнопка отправки */}
                    <div className="w-full flex items-center justify-between mt-4">
                      {
                        activeTab == 'login' ? (
                          <button
                            className="bg-mainColor hover:brightness-75 text-gray-700  font-medium py-2 px-4 rounded"
                            type="submit"
                            disabled={formik.isSubmitting}
                          >
                            Войти
                          </button>
                        ) : (
                          <button
                            className={`bg-mainColor hover:brightness-75 text-gray-700 font-medium py-2 px-4 rounded ${(!formik.isValid || !formik.values.name || !formik.values.surname)
                                ? 'opacity-50 cursor-not-allowed'
                                : ''
                              }`}
                            type="button"
                            disabled={!formik.isValid || !formik.values.name || !formik.values.surname || formik.isSubmitting}
                            onClick={() => sendEmail(formik)}
                          >
                            Зарегистрироваться
                          </button>
                        )
                      }



                      <div className="relative ml-4">
                        <ChangingLanguage onlyDesktop={true} />
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-600">
                          <i className="fas fa-chevron-down"></i>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
          </Form>
        )}
      </Formik>

      <ModalComponent
        isOpen={errorModal}
        onClose={() => {
          setErrorModal(null);
        }}
        headerContent={<h1 className={style.modal__header}>Уведомление</h1>}
        content={
          <p className={style.modal__text}>
            {`${errorModal?.errorMessage ? errorModal?.errorMessage : "ошибка."}`}
          </p>
        }
        customContent={
          <ModalButton
            type="button"
            onClick={() => {
              setErrorModal(null);
            }}
          >
            {t("mainButtons.accept")}
          </ModalButton>
        }
      />

      {alertOpen && (
        <AlertBox
          isOpen={alertOpen}
          setIsOpen={setAlertOpen}
        />
      )}
    </>


  );
};

export default Authorization;
